<template>
  <v-row class="pa-0 ma-0">
    <v-col
      v-if="label != null"
      cols="12" class="py-0 px-0 ma-0 text-caption">
      {{ label }}
    </v-col>
    <v-col cols="12" class="pt-0 mt-0 pl-0">
      <date-picker
        :disabled-date="notAfterToday"
        :value="internalValue"
        @input="updateValue"
        type="date"
        valueType="format"
        format="DD-MM-YYYY"
        :placeholder="label"
        :not-after="notAfter"
      ></date-picker>
    </v-col>
  </v-row>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';

export default {
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    notAfter: {
      type: Date,
      default: () => new Date() // Nuevo prop con valor por defecto
    }
  },
  data() {
    return {
      internalValue: this.value
        ? moment(this.value, 'YYYY-MM-DD').format('DD-MM-YYYY')
        : null
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue
        ? moment(newValue, 'YYYY-MM-DD').format('DD-MM-YYYY')
        : null;
    }
  },
  methods: {
    notAfterToday(date) {
      return date > this.notAfter;
    },
    updateValue(newValue) {
      // Si el usuario limpia el campo, regresamos null
      if (!newValue) {
        this.internalValue = null;
        this.$emit('input', null);
        return;
      }

      const m = moment(newValue, 'DD-MM-YYYY', true);

      // Si por alguna razón el valor es inválido, también regresamos null
      if (!m.isValid()) {
        this.internalValue = null;
        this.$emit('input', null);
        return;
      }

      const formattedValue = m.format('YYYY-MM-DD');
      this.internalValue = m.format('DD-MM-YYYY'); // opcional, por si quieres mantenerlo sincronizado
      this.$emit('input', formattedValue);
    }
  }
};
</script>

<style scoped>
.mx-datepicker {
  max-width: 380px !important;
}

.mx-datepicker-body {
  max-width: 380px !important;
}
</style>
